export const SET_NOVELTIES = "SET_NOVELTIES";